import {useSelector} from 'react-redux'

import SelectInput from '../../../../../../../Components/Common/Inputs/SelectInput/SelectInput'

export const MeasureSelectInpuit = ({...remainingProps}) => {
  const productMeasures = useSelector(state => state.Info.data.productMeasures)

  return (
    <SelectInput
      options={productMeasures}
      dataKey="measureId"
      dataLabel="measureTranslation"
      {...remainingProps}
    />
  )
}
